import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { IDENTIFIER } from '@core/tools/regexp';
import { BASE_DOC_URL, documentationContextIds } from './documentation.constant';

@Injectable({
  providedIn: 'root'
})
export class DocumentationService {

  constructor(
    private router: Router,
    private loco: TranslocoService
  ) { }

  getDocumentationUrl(tabId?: string): string {
    const context = this.getDocumentationContextId(tabId);
    // const currentLang = this.getBrowserLanguage();
    return context ? `${BASE_DOC_URL}fr/index-fr.html?contextId=${context}` : BASE_DOC_URL;
  }

  getBrowserLanguage(): string {
    return this.loco.getActiveLang();
  }

  getDocumentationContextId(tabId?: string): string | null {
    const segments = this.cleanSegments(this.router.url.split('/'));
    const route = tabId ? [...segments, tabId].join('/') : segments.join('/');
    return documentationContextIds.hasOwnProperty(route) ? documentationContextIds[route] : null;
  }

  cleanSegments(segments: string[]): string[] {
    const hasId = IDENTIFIER.test(segments[segments.length - 1]);
    return hasId ? segments.filter((segment: string) => segment !== segments[segments.length - 1]) : segments;
  }
}
